// src/components/FileUpload.js

import { svgImage } from '@/assets/svg/svg-icon';
import { Upload, message } from 'antd';
// import { useState, useEffect } from 'react';

const { Dragger } = Upload;
const FORBIDDEN_EXTENSIONS = ['.exe', '.js', '.sh', '.dmg', '.app', '.bat', '.cmd', '.php', '.py'];
const MAX_FILE_SIZE_MB = 5;


export const FileUpload = ({ value, onChange, maxCount = 1, showUploadList = true, fileUploadProps = {}, downloadFile, children }) => {

    const props = {
        name: 'file',
        multiple: maxCount > 1,
        maxCount: maxCount,
        showUploadList: showUploadList,
        fileList: value, // The list of files to display comes directly from the `value` prop.
        // listType: "picture", // Let antd handle displaying the list of files.
        onPreview: (file) => {
            if (downloadFile) {
                downloadFile(file);
            }
        },
        beforeUpload: (file) => {
            const isTooLarge = file.size / 1024 / 1024 > MAX_FILE_SIZE_MB;
            if (isTooLarge) {
                message.error(`'${file.name}' is too large (Max: ${MAX_FILE_SIZE_MB}MB).`);
                return Upload.LIST_IGNORE;
            }

            const hasForbiddenExtension = FORBIDDEN_EXTENSIONS.some(ext =>
                file.name.toLowerCase().endsWith(ext)
            );
            if (hasForbiddenExtension) {
                message.error(`'${file.name}' is a forbidden file type.`);
                return Upload.LIST_IGNORE;
            }
            
            return false; // Prevent automatic upload.
        },

        // This is the key communication channel back to the form.
        onChange: (info) => {
            // `info.fileList` is the new, complete list of files.
            // We call the `onChange` prop from the parent Form.Item with this new list.
            if (onChange) {
                onChange(info.fileList);
            }
        },

        ...fileUploadProps,
    };

    return (
        <>
            {/* Use the Dragger component for a built-in drop zone */}
            <Dragger {...props}>
                {/* LOGIC: If children (custom button) exist, show them. Otherwise show default dropzone. */}
                {children ? children : (
                    <>
                        <p className="ant-upload-drag-icon">
                            {svgImage.dropImage}
                        </p>
                        <p className="ant-upload-text">Drop your file here, or <span className="browse">browse</span></p>
                        <p className="ant-upload-hint">
                            Max {props.maxCount} files. Max file size is {MAX_FILE_SIZE_MB}MB.
                        </p>
                    </>
                )}
            </Dragger>
        </>
    );
};